/**
 * @file Allow using app feature flags
 */
import { hasWwDebugUrlParam } from '@@/bits/dev_url_params'
import environment from '@@/bits/environment'
import window from '@@/bits/global'

type CurrentFlags =
  | 'accessControlSettingsV2'
  | 'accessControlSettingsV2RetroactiveUpdate'
  | 'actionMenu2026'
  | 'addPostLink'
  | 'adminAnalyticsNuxtUi'
  | 'affiliateSignupLink'
  | 'aiImageSearch'
  | 'aiPermissionsForAiRecipes'
  | 'aiPermissionsForImageAndSpeechGeneration'
  | 'aiSuggestionsOnMakePage'
  | 'allSlideAsImageWithBanksy'
  | 'arLensesPreview'
  | 'attachmentPreviewWidthAdjustmentForGridFormat'
  | 'autoContentModeration'
  | 'banksy'
  | 'banksyDev'
  | 'billingAddress'
  | 'bulkEmailChangeForLibraries'
  | 'brahmsCheck'
  | 'campus'
  | 'changeEmailVerification'
  | 'classesV1'
  | 'classInformation'
  | 'classlinkSso'
  | 'classroomLicensesV2'
  | 'classroomPlanPricingExperiment'
  | 'cleverSso'
  | 'commandBar'
  | 'commentAutoPublishOnUpload'
  | 'crossPlatformAttachmentSettings'
  | 'currentSlideAsImageWithBanksy'
  | 'customPostUserProperty'
  | 'customPostVoteAndRatingProperties'
  | 'dailyEmailDigestTeacher'
  | 'dashboardAnnouncement'
  | 'dashboardUpgradeCta'
  | 'dashHeaderCtaButton'
  | 'dashRecentsGroupByLibrary'
  | 'debugFrontend'
  | 'defaultDashboardLibraryNavigation'
  | 'demoPadletPanel'
  | 'demoPadletSignup'
  | 'deprecateArsPlans'
  | 'deprecateDrivePage'
  | 'deprecateGoldPlans'
  | 'deviceIdLocalStorageReseed'
  | 'deviceUploads'
  | 'displayLocalPartRules'
  | 'downloadWallAttachmentsV2'
  | 'editThumbnail'
  | 'editThumbnailForAudioVideoFiles'
  | 'embeddedPadletsOnExpandedPost'
  | 'embedLogin'
  | 'exitTicket'
  | 'fasterDashSettings'
  | 'featuredSection'
  | 'fetchLinksWithWishes'
  | 'frontChat'
  | 'fullClientSurface'
  | 'galleryTemplates'
  | 'googleAppLicensing'
  | 'googleClassroom'
  | 'googleClassroomGrading'
  | 'googleWorkspaceRostering'
  | 'grading'
  | 'groupPostsV2'
  | 'higherMonthlyPricingPlans'
  | 'internalNavigateImmediately'
  | 'joypixels8p0'
  | 'latamSpanishLanguage'
  | 'libraryGoogleAppLicensing'
  | 'libraryLoginOtpToggle'
  | 'librarySamlLogin'
  | 'librarySettingsConnectionsTab'
  | 'lmsUserGroupSync'
  | 'loadWishesViaSortBy'
  | 'lottieWebWorker'
  | 'ltiCourseDuplication'
  | 'magicPadlet'
  | 'makePageSimplifiedLayoutExperiment'
  | 'maoriLanguage'
  | 'membersSelectV2'
  | 'microsoftOneDrivePicker'
  | 'microsoftTeams'
  | 'mobileDeviceDprOverride'
  | 'notifyFailedPayments'
  | 'posthogNpsSurvey'
  | 'posthogNpsSurveyAlwaysShow'
  | 'onboardingDemoV2'
  | 'onboardingDemoV2Copy'
  | 'onboardingGridLayout'
  | 'onboardingPanel'
  | 'openInAppBanner'
  | 'openInMobileApp'
  | 'padletAnalytics'
  | 'pdndSurfaceGrid'
  | 'pdndSurfaceMap'
  | 'pdndSurfaceMatrix'
  | 'personalPricingPlansExperiment'
  | 'personalPricingPlansExperimentV2'
  | 'piChatV2'
  | 'piInputV2'
  | 'piSandboxChat'
  | 'piSubmissionFormWidget'
  | 'piUndo'
  | 'platinumResellerSelfServe'
  | 'playVideoInExpanded'
  | 'postComposerAttachmentPickerV2'
  | 'postVisibility'
  | 'posthogSessionRecording'
  | 'pptxImport'
  | 'prefetchSurface'
  | 'publicApi'
  | 'pwaInstallButton'
  | 'reactionsToCustomPropertiesMigration'
  | 'remakeLink'
  | 'remakeSettingV2'
  | 'removeArchive'
  | 'renameAdminOwnerToCreator'
  | 'requirePaymentMethodToUndoCancellation'
  | 'rostering'
  | 'routeToEurope'
  | 'samlIdp'
  | 'samlSetup'
  | 'sandboxAi'
  | 'sandboxCode'
  | 'whiteboardPermissionsV2'
  | 'sandboxGeoShapeBorderSettings'
  | 'sandboxNotePlaceholders'
  | 'schoolLibraryFreeze'
  | 'schoolLibraryPermissions'
  | 'schoolLibrarySSO'
  | 'schoolSelectionForTeachers'
  | 'scrollSmoothnessTracking'
  | 'selfServeFreeTrial'
  | 'shareShortcuts'
  | 'showAnonymousUserNames'
  | 'showCommandPalette'
  | 'showInvitedLibraryUsers'
  | 'sidePanelsV2'
  | 'signUpSurface'
  | 'slideshowRemote'
  | 'slideshowSwipeNavigation'
  | 'smartSuggestionsExperiment'
  | 'structuredClassInformation'
  | 'suggestedTemplates'
  | 'surfaceAiChat'
  | 'surfaceAiChatSchools'
  | 'surfaceAiChatSchoolsPermission'
  | 'surfaceCommentAttachmentDownload'
  | 'surfaceCommentsPerPost'
  | 'surfaceCommentVideoPlayer'
  | 'surfaceConnectionsChange'
  | 'surfaceContributorsModalV2'
  | 'surfacePostVideoPlayer'
  | 'surfaceLibraryOrgVisitorPermissions'
  | 'surfaceMapsV2'
  | 'surfaceRoleBadges'
  | 'swipeNavigationOnBoardExpandedView'
  | 'tamilLanguage'
  | 'taxIdOnCheckout'
  | 'threeDAttachment'
  | 'templatesWithNewSidebar'
  | 'transferPadletTool'
  | 'transferPostWithCustomProperties'
  | 'transferSchoolPadletPermission'
  | 'translatePadlet'
  | 'translatePadletV2'
  | 'translationFeedback'
  | 'translationReporter'
  | 'turnstileOnSignup'
  | 'undoRedoDeleteSectionActions'
  | 'unicodeFontLoading'
  | 'unlimitedSandboxesEventOverQuotaBanner'
  | 'unlimitedSandboxesV2'
  | 'upgradeModalCopyAExperiment'
  | 'upgradeModalSingleStepExperiment'
  | 'virtualFieldTrip'
  | 'virtualFieldTripNarration'
  | 'virtualizedDashboard'
  | 'virtualizedPostsGrid'
  | 'wallCardMaxWidth'
  | 'wallContentProtection'
  | 'wallEngagementTime'
  | 'wallEngagementTimeTracking'
  | 'wallPasswordAccessLink'
  | 'weeklyEmailDigestTeacher'
  | 'workspaceLoginRedirect'
  | 'yodishLanguage'
  | 'zapierIntegration'
  | 'nativeAccountSwitcher'
  | 'captionsTranslation'
  | 'arcadeAttachment'
  | 'arcadeGameInsightsEmailTeacher'

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  const ww = window.ww || {}
  const viteAppFlip =
    window.wwStartingState != null && typeof window.wwStartingState === 'function' ? window.wwStartingState().flip : {}
  const flip = ww.flip || ww.vueStartingState?.flip || viteAppFlip || {}
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

const isDebugMode =
  (environment === 'test' && ['true', 'yes', '1'].includes(process.env.WW_DEBUG ?? '')) ||
  isAppUsing('debugFrontend') ||
  hasWwDebugUrlParam()

if (environment !== 'production' && isAppUsing('debugFrontend')) {
  console.log('Already debugging frontend in dev.') // goodcheck-disable-line
}

// If on padlet.dev, use the local Banksy server to test PDF exports.
// Banksy and Banksy Dev on Cloud Run won't work because they cannot access a padlet.dev padlet.
// You will need to run the Banksy server first before you can test PDF exports.
// See: /services/banksy/README.md
const isAppUsingBanksyLocalDev = environment === 'development'

export { isAppUsing, isAppUsingBanksyLocalDev, isDebugMode }
export type { CurrentFlags }
